import { Box, Button, Stack, Typography } from "@mui/material";
import React from "react";
import { useTheme } from "@mui/material/styles";
import useResponsive from "../hooks/useResponsive";


const headerSty = {
  fontFamily: "Lexend",
  letterSpacing: "0.01em",
  fontWeight: 400,
};
const contentSty = {
  fontFamily: "Lexend",
  letterSpacing: "0.01em",
  fontWeight: 400,
};

interface ProfileUIProps {
  name: string;
  email: string;
  staffId: string;
}
export const ProfileUI = ({ name, email, staffId }: ProfileUIProps) => {
  const theme = useTheme();
  const isMedium = useResponsive("down", "md", "xl");
  const isSmall = useResponsive("down", "sm", "xl");
  return (
    <Box
      sx={{
        backgroundColor: "#F7F8F9",
        borderRadius: "4",
        paddingLeft: 3,
        paddingY: 2,
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        minHeight: 62,
      }}
    >
      <Stack sx={{ marginX: 3, marginY: isMedium ? 2 : 0 }}>
        <img
          src="/assets/icons/employee-icon.png"
          alt=""
          width={60}
          height={60}
        />
      </Stack>
      <Stack
        direction={"column"}
        justifyContent={"space-between"}
        sx={{ paddingY: 1, marginX: 3, marginY: isMedium ? 2 : 0 }}
      >
        <Typography
          variant="caption"
          sx={{ ...headerSty, color: theme.palette.neutral.contrastText }}
        >
          Name
        </Typography>
        <Typography
          variant="subtitle2"
          sx={{ ...contentSty, color: theme.palette.neutral.main }}
        >
          {name}
        </Typography>
      </Stack>
      <Stack
        direction={"column"}
        justifyContent={"space-between"}
        sx={{ paddingY: 1, marginX: 3, marginY: isMedium ? 2 : 0 }}
      >
        <Typography
          variant="caption"
          sx={{ ...headerSty, color: theme.palette.neutral.contrastText }}
        >
          Email
        </Typography>
        <Typography
          variant="subtitle2"
          sx={{ ...contentSty, color: theme.palette.neutral.main }}
        >
          {email}
        </Typography>
      </Stack>
      <Stack
        direction={"column"}
        justifyContent={"space-between"}
        sx={{ paddingY: 1, marginX: 3, marginY: isMedium ? 2 : 0 }}
      >
        <Typography
          variant="caption"
          sx={{ ...headerSty, color: theme.palette.neutral.contrastText }}
        >
          Staff ID
        </Typography>
        <Typography
          variant="subtitle2"
          sx={{ ...contentSty, color: theme.palette.neutral.main }}
        >
          {staffId}
        </Typography>
      </Stack>{" "}
    </Box>
  );
};

interface DetailsUIProps {
  type: string;
  title: string;
  department: string;
  startDate: string;
  endDate: string;
}
export const DetailsUI = ({
  type,
  title,
  department,
  startDate,
  endDate,
}: DetailsUIProps) => {
  const theme = useTheme();
  const isMedium = useResponsive("down", "md", "xl");

  return (
    <Box
      sx={{
        backgroundColor: "#F7F8F9",
        borderRadius: "4",
        paddingLeft: 3,
        paddingY: "1.3rem",
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        minHeight: 70,
      }}
    >
      <Stack
        direction={"column"}
        justifyContent={"space-between"}
        sx={{
          paddingY: 1,
          marginX: isMedium ? 3 : 4,
          marginY: isMedium ? 2 : 0,
        }}
      >
        <Typography
          variant="caption"
          sx={{ ...headerSty, color: theme.palette.neutral.contrastText }}
        >
          Type
        </Typography>
        <Typography
          variant="subtitle2"
          sx={{ ...contentSty, color: theme.palette.neutral.main }}
        >
          {type}
        </Typography>
      </Stack>
      <Stack
        direction={"column"}
        justifyContent={"space-between"}
        sx={{
          paddingY: 1,
          marginX: isMedium ? 3 : 4,
          marginY: isMedium ? 2 : 0,
        }}
      >
        <Typography
          variant="caption"
          sx={{ ...headerSty, color: theme.palette.neutral.contrastText }}
        >
          Title
        </Typography>
        <Typography
          variant="subtitle2"
          sx={{ ...contentSty, color: theme.palette.neutral.main }}
        >
          {title}
        </Typography>
      </Stack>
      <Stack
        direction={"column"}
        justifyContent={"space-between"}
        sx={{
          paddingY: 1,
          marginX: isMedium ? 3 : 4,
          marginY: isMedium ? 2 : 0,
        }}
      >
        <Typography
          variant="caption"
          sx={{ ...headerSty, color: theme.palette.neutral.contrastText }}
        >
          Department
        </Typography>
        <Typography
          variant="subtitle2"
          sx={{ ...contentSty, color: theme.palette.neutral.main }}
        >
          {department}
        </Typography>
      </Stack>
      <Stack
        direction={"column"}
        justifyContent={"space-between"}
        sx={{
          paddingY: 1,
          marginX: isMedium ? 3 : 4,
          marginY: isMedium ? 2 : 0,
        }}
      >
        <Typography
          variant="caption"
          sx={{ ...headerSty, color: theme.palette.neutral.contrastText }}
        >
          Start Date
        </Typography>
        <Typography
          variant="subtitle2"
          sx={{ ...contentSty, color: theme.palette.neutral.main }}
        >
          {startDate}
        </Typography>
      </Stack>
      <Stack
        direction={"column"}
        justifyContent={"space-between"}
        sx={{
          paddingY: 1,
          marginX: isMedium ? 3 : 4,
          marginY: isMedium ? 2 : 0,
        }}
      >
        <Typography
          variant="caption"
          sx={{ ...headerSty, color: theme.palette.neutral.contrastText }}
        >
          End Date
        </Typography>
        <Typography
          variant="subtitle2"
          sx={{ ...contentSty, color: theme.palette.neutral.main }}
        >
          {endDate}
        </Typography>
      </Stack>{" "}
    </Box>
  );
};

export const EmploymentInfoUI = ({}) => {
  const theme = useTheme();
  const isMedium = useResponsive("down", "md", "xl");

  return (
    <Box
      sx={{
        backgroundColor: "#F7F8F9",
        borderRadius: "4",
        paddingLeft: 3,
        paddingY: 2,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: 62,
      }}
    >
      <Stack
        sx={{ marginX: 3, minHeight: 60 }}
        direction={isMedium ? "column" : "row"}
        alignItems={"center"}
      >
        <img src="/assets/icons/lock-icon.png" alt="" width={40} height={40} />
        <Stack
          direction={"column"}
          justifyContent={"space-between"}
          sx={{ paddingY: 1, marginX: 3 }}
        >
          <Typography
            variant="caption"
            sx={{
              ...headerSty,
              color: theme.palette.neutral.contrastText,
              textAlign: isMedium ? "center" : "left",
            }}
          >
            Subscription
          </Typography>
          <Typography
            variant="subtitle2"
            sx={{ ...contentSty, color: theme.palette.neutral.main }}
          >
            Upgrade Subscription to view
          </Typography>
        </Stack>
      </Stack>
    </Box>
  );
};

interface EmployeeDataProps {
  startDate: string;
  endDate: string;
  requestType: string;
  amount: string;
  availableTime: string;
}

export const EmployeeRequest = ({
  startDate,
  endDate,
  requestType,
  amount,
  availableTime,
}: EmployeeDataProps) => {
  const theme = useTheme();
  const isMedium = useResponsive("down", "md", "xl");
  return (
    <Box
      sx={{
        border: `1px solid #DCE1EA`,
      }}
    >
      <Box sx={{display: 'flex', flexDirection: isMedium ? 'column' : 'row', py: isMedium ? 3 : 4, px: isMedium ? 3 : 4}}>
        <Stack sx={{width : isMedium ? "100%" : '25%', my: 2}}>
          <Stack direction="row" sx={{gap: 2, my: 1}}>
            <img src="/assets/icons/clock-icon.svg" alt="" width={23} height={23} />
            <Typography variant="subtitle1" color={"primary"}> Pending Approval</Typography>
          </Stack>
          <Stack direction="row" sx={{gap: 2, paddingLeft: 3}}>
            <Typography sx={{color: '#9199A8', fontSize: 9, letterSpacing: '1%',}}>Application ID:</Typography>
            <Typography sx={{color: '#9199A8', fontSize: 9, letterSpacing: '1%',}}>50001890</Typography>
          </Stack>
        </Stack>
        <Stack sx={{width: isMedium ? "100%" : '55%', my: 2}}>
          <Typography color={'neutral'} sx={{
            fontFamily: 'Lexend',
            fontSize: '10px',
            fontWeight: 300,
            lineHeight: '24.34px',
            letterSpacing: '0.01em',
            
            
          }}></Typography>
        </Stack>
        <Stack direction="row" sx={{width: isMedium ? "100%" : '30%', gap: 3, my: 2}} justifyContent={'flex-end'}>
          <Button variant="outlined" sx={{borderRadius: '12px', height: 45}}>Reject</Button>
          <Button sx={{borderRadius: '12px', height: 45}} variant="contained">Approve</Button>
        </Stack>
      </Box>
      <Box
        sx={{
          backgroundColor: "#F7F8F9",
          borderRadius: "4",
          paddingLeft: 3,
          paddingY: "1.3rem",
          display: "flex",
          flexDirection: "row",
          flexWrap: "wrap",
          minHeight: 70,
        }}
      >
        <Stack
          direction={"column"}
          justifyContent={"space-between"}
          sx={{
            paddingY: 1,
            marginX: isMedium ? 3 : 4,
            marginY: isMedium ? 2 : 0,
          }}
        >
          <Typography
            variant="caption"
            sx={{ ...headerSty, color: theme.palette.neutral.contrastText }}
          >
            Request type
          </Typography>
          <Typography
            variant="subtitle2"
            sx={{ ...contentSty, color: theme.palette.neutral.main }}
          >
            {requestType}
          </Typography>
        </Stack>
        <Stack
          direction={"column"}
          justifyContent={"space-between"}
          sx={{
            paddingY: 1,
            marginX: isMedium ? 3 : 4,
            marginY: isMedium ? 2 : 0,
          }}
        >
          <Typography
            variant="caption"
            sx={{ ...headerSty, color: theme.palette.neutral.contrastText }}
          >
            Amount
          </Typography>
          <Typography
            variant="subtitle2"
            sx={{ ...contentSty, color: theme.palette.neutral.main }}
          >
            {amount}
          </Typography>
        </Stack>

        <Stack
          direction={"column"}
          justifyContent={"space-between"}
          sx={{
            paddingY: 1,
            marginX: isMedium ? 3 : 4,
            marginY: isMedium ? 2 : 0,
          }}
        >
          <Typography
            variant="caption"
            sx={{ ...headerSty, color: theme.palette.neutral.contrastText }}
          >
            Start Date
          </Typography>
          <Typography
            variant="subtitle2"
            sx={{ ...contentSty, color: theme.palette.neutral.main }}
          >
            {startDate}
          </Typography>
        </Stack>
        <Stack
          direction={"column"}
          justifyContent={"space-between"}
          sx={{
            paddingY: 1,
            marginX: isMedium ? 3 : 4,
            marginY: isMedium ? 2 : 0,
          }}
        >
          <Typography
            variant="caption"
            sx={{ ...headerSty, color: theme.palette.neutral.contrastText }}
          >
            End Date
          </Typography>
          <Typography
            variant="subtitle2"
            sx={{ ...contentSty, color: theme.palette.neutral.main }}
          >
            {endDate}
          </Typography>
        </Stack>
        <Stack
          direction={"column"}
          justifyContent={"space-between"}
          sx={{
            paddingY: 1,
            marginX: isMedium ? 3 : 4,
            marginY: isMedium ? 2 : 0,
          }}
        >
          <Typography
            variant="caption"
            sx={{ ...headerSty, color: theme.palette.neutral.contrastText }}
          >
            Available time
          </Typography>
          <Typography
            variant="subtitle2"
            sx={{ ...contentSty, color: theme.palette.neutral.main }}
          >
            {availableTime}
          </Typography>
        </Stack>
      </Box>
    </Box>
  );
};
